export const bools_types = new Set([
  'Bundle?',
  'Award Winner?',
  'Film/TV Adaptation?',
  'Search External Titles?',
  'NYT Bestseller?',
  'Author with Series',
  'Promoted Title Today?',
  'Show all Eligible Titles?',
]);

/* 
    To include title in nomination result where certain performance data is not available as per
    https://openroadmedia.atlassian.net/browse/ORMTECH-1688
*/
export const NATypes = new Set([
  'rank.currentRank',
  'rank.last90rank',
  'latestRating',
  'latestReviews',
  'consumerPrice.last7consumerPrice',
  'consumerPrice.last30consumerPrice',
  'consumerPrice.last90consumerPrice',
  'salesByRetailer.Amazon.last30Proceeds',
  'sales.last30Units',
  'sales.last7Units',
]);

//Filters.Field value
export const FiltersWithStringOperator = new Set(['publisher', 'bisacs']);
export const STRING_OPERATOR = [
  {
    Comparison_Operator: 'IN',
    label: 'In',
    value: '$in',
  },
  {
    Comparison_Operator: 'NOT IN',
    label: 'Not In',
    value: '$nin',
  },
];

export const TEXT_OPERATOR = [
  {
    Comparison_Operator: 'CONTAINS',
    label: 'Contains',
    value: 'contains',
  },
  {
    Comparison_Operator: 'DOES NOT CONTAIN',
    label: 'Does not contain',
    value: 'not_contains',
  },
  {
    Comparison_Operator: 'EQUALS',
    label: 'Equals',
    value: 'equals',
  },
  {
    Comparison_Operator: 'DOES NOT EQUAL',
    label: 'Does not equal',
    value: 'not_equals',
  },
  {
    Comparison_Operator: 'STARTS WITH',
    label: 'Starts With',
    value: 'starts_with',
  },
];

export const ALERT_FOR_TEXT_OPERATORS = {
  contains: 'Enter one word only. Records that contain the entered words will be matched.',
  not_contains: 'Enter one word only. Records that do not contain this word will be matched.',
  equals: 'Enter one exact word. Records that do not exactly match this value will be matched.',
  not_equals: 'Enter one exact word. Records that do not exactly match this value will be matched.',
  starts_with: 'You can enter multiple words, separated by commas. Example: science, music',
};

export const COMP_OPERATOR = [
  {
    Comparison_Operator: 'GREATER_THAN_EQUAL',
    label: '>=',
    value: '$gte',
  },
  {
    Comparison_Operator: 'GREATER_THAN',
    label: '>',
    value: '$gt',
  },
  {
    Comparison_Operator: 'EQUAL',
    label: '==',
    value: '$eq',
  },
  {
    Comparison_Operator: 'LESS_THAN_EQUAL',
    label: '<=',
    value: '$lte',
  },
  {
    Comparison_Operator: 'LESS_THAN',
    label: '<',
    value: '$lt',
  },
];

export const COMP_OPERATOR_WITH_RANGE = [
  {
    Comparison_Operator: 'GREATER_THAN_EQUAL',
    label: '>=',
    value: '$gte',
  },
  {
    Comparison_Operator: 'GREATER_THAN',
    label: '>',
    value: '$gt',
  },
  {
    Comparison_Operator: 'EQUAL',
    label: '==',
    value: '$eq',
  },
  {
    Comparison_Operator: 'LESS_THAN_EQUAL',
    label: '<=',
    value: '$lte',
  },
  {
    Comparison_Operator: 'LESS_THAN',
    label: '<',
    value: '$lt',
  },
  {
    Comparison_Operator: 'RANGE',
    label: 'R',
    value: 'Range',
  },
];

export const BOOLEAN_SELECT = [
  {
    value: 'Yes',
    label: 'Yes',
  },
  {
    value: 'No',
    label: 'No',
  },
  // Made select clearable, so not required
  // {
  //   value: '',
  //   label: '',
  // },
];

export const INVERSE_MONGO_OPERATORS = {
  $gte: '$lt',
  $gt: '$lte',
  $lte: '$gt',
  $lt: '$gte',
  $eq: '$ne',
  $ne: '$eq',
};

export const BUSINESS_AREA_OPTIONS = [
  { label: 'Publishing Backlist', value: 'Publishing Backlist' },
  { label: 'Publishing Prior Year', value: 'Publishing Prior Year' },
  { label: 'Publishing Frontlist', value: 'Publishing Frontlist' },
  { label: 'Ignition Backlist', value: 'Ignition Backlist' },
  { label: 'Ignition Prior Year', value: 'Ignition Prior Year' },
  { label: 'Ignition Frontlist', value: 'Ignition Frontlist' },
  { label: 'Bloodhound Backlist', value: 'Bloodhound Backlist' },
  { label: 'Bloodhound Prior Year', value: 'Bloodhound Prior Year' },
  { label: 'Bloodhound Frontlist', value: 'Bloodhound Frontlist' },
];

export const SYNCHRONIZER_TIMEFRAME_OPTIONS = [
  { value: 'MTD', label: 'MTD' },
  { value: '1', label: '1 Year' },
  { value: '2', label: '2 Years' },
  { value: '3', label: '3 Years' },
];

export const SYNCHRONIZER_PROMO_OPTIONS = [
  { value: 'Promote', label: 'Promote' },
  // eslint-disable-next-line quotes
  { value: "Don't promote", label: "Don't Promote" },
  { value: 'Review', label: 'Review' },
];

export const SYNCHRONIZER_PRIORITY_BUCKET_OPTIONS = [
  { value: 'P1', label: 'P1' },
  { value: 'P2', label: 'P2' },
  { value: 'P3', label: 'P3' },
];
